"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEEDBACK_BENEFIT_DIALOG = void 0;
const FEEDBACK_BENEFIT_DIALOG = exports.FEEDBACK_BENEFIT_DIALOG = 'feedback-benefit-dialog';
